import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loadingRequests = 0;
  isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  showSpinner() {
    this.loadingRequests++;
    this.setLoading();
  }

  hideSpinner() {
    if (this.loadingRequests > 0) {
      this.loadingRequests--;
      this.setLoading();
    }
  }

  private setLoading() {
    setTimeout(() => {
      if (this.loadingRequests === 1) {
        this.isLoading.next(true);
      } else if (this.loadingRequests === 0) {
        this.isLoading.next(false);
      }
    });
  }
}
